import React from "react";
import Layout from "../../shared/Layout/Layout";
import leftArrow from "../../assets/leftArrow.svg";
import Card from "../../components/_change_password/Card/Card";
import { useNavigate } from "react-router-dom";
import styles from "./ChangePassword.module.scss";

const ChangePassword = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.leftArrow} onClick={() => navigate("/")}>
            <img src={leftArrow} alt="go-back" />
          </div>
          <h1>Change Password</h1>

          <Card />
        </div>
      </div>
    </Layout>
  );
};

export default ChangePassword;
